// src/utils/storageUpload.js
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import { auth, storage } from "../config/firebase";

function safeName(name) {
  return String(name || "file")
    .trim()
    .replace(/[^a-zA-Z0-9._-]+/g, "_")
    .slice(0, 120);
}

/**
 * Faz upload de um File (input type=file) para o Firebase Storage e retorna a URL.
 * Observação: o caminho já inclui grupoId para manter organização multi-tenant.
 */
export async function uploadToStorage({
  grupoId,
  empresaId,
  pasta,
  file,
  filenamePrefix,
}) {
  if (!grupoId) throw new Error("grupoId ausente");
  if (!file) throw new Error("Arquivo ausente");

  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error("Sessão expirada no Firebase Auth. Faça login novamente.");
  }

  await currentUser.getIdToken(true);

  const ext = safeName(file.name).split(".").pop();
  const stamp = Date.now();
  const name = safeName(`${filenamePrefix || "upload"}_${stamp}.${ext || "bin"}`);

  const path = [
    "mamute",
    "grupos",
    safeName(grupoId),
    empresaId ? `empresas/${safeName(empresaId)}` : null,
    pasta ? safeName(pasta) : "uploads",
    name,
  ]
    .filter(Boolean)
    .join("/");

  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
}
